'use client'
import React, { useState, useEffect } from "react"
// import Image from 'next/image'
import styles from './styles/page.module.scss'

import LoadingDialog from "./components/LoadingDialog"
import Canvas from '@/app/components/BlankCanvas';

export default function Home() {
  const [loading, setLoading] = useState(true)
  const [videosLoaded, setVideosLoaded] = useState(false)

  const handleClose = () => {
    // Only allow closing if videos are loaded
    if (videosLoaded) {
      setLoading(false)
    }
  }

  useEffect(() => {
    const videoElements = document.querySelectorAll('video');
    let loadedCount = 0;

    const handleVideoLoad = () => {
      loadedCount++;
      if (loadedCount === videoElements.length) {
        setVideosLoaded(true);
      }
    };

    videoElements.forEach(video => {
      if (video.readyState >= 3) { // HAVE_FUTURE_DATA
        handleVideoLoad();
      } else {
        video.addEventListener('loadeddata', handleVideoLoad);
      }
    });

    return () => {
      videoElements.forEach(video => {
        video.removeEventListener('loadeddata', handleVideoLoad);
      });
    };
  }, []);

  return (
    <Canvas videosLoaded={videosLoaded}>
      <main className={styles.main}>
        <div>
            <section>
              <LoadingDialog
                open={loading}
                duration={10}
                onClose={handleClose}
                />

                <video 
                    muted 
                    style={{ width: '100%', height: '100%', objectFit: 'contain', position: 'fixed', left: '-100%', top: '-100%' }} 
                    preload="auto"
                >
                    <source src="/videos/preview-asianmodels.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                </video>

                <video 
                    muted 
                    style={{ width: '100%', height: '100%', objectFit: 'contain', position: 'fixed', left: '-100%', top: '-100%' }} 
                    preload="auto"
                >
                    <source src="/videos/guideline-models.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                </video>

                <video 
                    muted 
                    style={{ width: '100%', height: '100%', objectFit: 'contain', position: 'fixed', left: '-100%', top: '-100%' }} 
                    preload="auto"
                >
                    <source src="/videos/guideline-timer.webm" type="video/webm" />
                    Your browser does not support the video tag.
                </video>


                <video 
                    muted 
                    style={{ width: '100%', height: '100%', objectFit: 'contain', position: 'fixed', left: '-100%', top: '-100%' }} 
                    preload="auto"
                >
                    <source src="/videos/tat-sticker.webm" type="video/webm" />
                    Your browser does not support the video tag.
                </video>

                <video 
                    muted 
                    style={{ width: '100%', height: '100%', objectFit: 'contain', position: 'fixed', left: '-100%', top: '-100%' }} 
                    preload="auto"
                >
                    <source src="/videos/zoom-hand.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </section>
          </div>
      </main>
    </Canvas>
  )
}
